module.exports = __webpack_public_path__ + "static/hymots_license-ae845b5e529763c430fff51e84f333d5.png";